export const LAYOUT_INITIALIZE = 'LAYOUT_INITIALIZE';
export const LAYOUT_SHOW_LOADING = 'LAYOUT_SHOW_LOADING';
export const LAYOUT_HIDE_LOADING = 'LAYOUT_HIDE_LOADING';
export const LAYOUT_COLLAPSE = 'LAYOUT_COLLAPSE';
export const LAYOUT_EXPAND = 'LAYOUT_EXPAND';



// WEBPACK FOOTER //
// ./webpack/assets/javascripts/react_app/components/Layout/LayoutConstants.js